import React, { useState } from 'react';
import Select from 'react-select';
import './DropDown.css';

function Dropdown({
  options,
  selectedTab,
  selectedOption,
  handleSelectChange,
  setSelectedTab,
  setSelectedOption,
}) {
  return (
    <Select
      closeMenuOnSelect={false}
      // options={options}
      options={options}
      value={selectedOption}
      // defaultValue={[options[0], options[1]]}
      onChange={handleSelectChange}
      className='custom-select'
      classNamePrefix='react-select'
      isMulti
      styles={{
        control: (base, state) => ({
          ...base,
          minHeight: '38px',
          borderColor: state.isFocused ? '#4caf50' : '#ccc',
          boxShadow: state.isFocused ? '0 0 0 1px #4caf50' : 'none',
          '&:hover': {
            borderColor: '#4caf50',
          },
        }),
        multiValue: (base) => ({
          ...base,
          backgroundColor: '#e8f5e9',
        }),
        multiValueLabel: (base) => ({
          ...base,
          color: '#388e3c',
        }),
        multiValueRemove: (base) => ({
          ...base,
          color: '#2e7d32',
          ':hover': {
            backgroundColor: '#c8e6c9',
            color: '#1b5e20',
          },
        }),
        option: (base, state) => ({
          ...base,
          backgroundColor: state.isSelected
            ? '#4caf50'
            : state.isFocused
            ? '#a5d6a7'
            : 'white',
          color: state.isSelected ? 'white' : 'black',
          '&:hover': {
            backgroundColor: '#a5d6a7',
          },
        }),
        dropdownIndicator: (base, state) => ({
          ...base,
          color: state.isFocused ? '#4caf50' : '#666',
          '&:hover': {
            color: '#4caf50',
          },
        }),
      }}
    />
  );
}

export default Dropdown;
